import { Table } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledSortableHeaderCell = styled(Table.SortableHeaderCell)<{ minWidth?: number }>`
  ${({ minWidth }) => minWidth && `min-width: ${minWidth}px;`}
`;
